import React, {useState} from 'react';
import OrgChartImg from '../img/img_organizationchart.png';
import Text from '../../../common/Text.js';
import '../css/OrgChart.css' ;

function OrgChart() {


     return (
        <div className='Top-root'>
            <div className='root-main'>
                <div className='header-container'>
                    <Text variant="titlename" className='header-title'>조직도</Text>
                    <div className='header-title-line'></div>
                </div>
                <div className='OrgChart-container'><img src={OrgChartImg}/>
                </div>
            </div>
        </div>
        
     );
 }
 
 export default OrgChart;